export const userConstants = {
  AGE_COOKIE_NAME: 'ageVerified'
}
